import { Component } from 'react';
import PropTypes from 'prop-types';
import PillButton from 'src/common/components/shared/button/PillButton';
import {
  UNLOCK_FAILURE_TEXT,
  UNLOCK_SUBMIT_TEXT,
} from 'src/common/constants/localizations/unlock';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import unlockCss from './unlock.module.scss';

const styles = {
  buttonContainer: {
    marginTop: 20,
  },
};

class UnlockFailureView extends Component {
  static propTypes = {
    unlockActions: PropTypes.shape({
      unlockClosed: PropTypes.func.isRequired,
    }),
  };

  static contextType = LocationAndLocalizationContext;

  handleClick = () => {
    const { unlockActions } = this.props;
    unlockActions.unlockClosed();
  };

  render() {
    const { getLocalizedText } = this.context;

    return (
      <div data-testid="unlockFailure">
        <p className={unlockCss.title}>
          {getLocalizedText(UNLOCK_FAILURE_TEXT)}
        </p>
        <div className={unlockCss.section}>
          <div className="row">
            <div
              className="col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-1 col-md-10"
              style={styles.buttonContainer}
            >
              <PillButton
                id="unlockOkayButton"
                type="submit"
                label={getLocalizedText(UNLOCK_SUBMIT_TEXT)}
                onClick={this.handleClick}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UnlockFailureView;
